import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: null,
  props: {},
};

const confirmDialogSlice = createSlice({
  name: 'confirmDialog',
  initialState,
  reducers: {
    showConfirmDialog: (state, { payload: { type, props } }) => {
      state.type = type;
      state.props = { ...state.props, ...props };
    },
    hideConfirmDialog: () => initialState,
  },
});

export const { showConfirmDialog, hideConfirmDialog } = confirmDialogSlice.actions;

export default confirmDialogSlice.reducer;
